import React from 'react';
import { SlideLayout } from './SlideLayout';
import { motion } from 'framer-motion';
import { Flame, Target, Users, Zap, Award, CheckCircle2 } from 'lucide-react';
export function Slide5_Forge() {
  const day1Curriculum = ['The 12 Truths of Direct Sales', 'Core Values of Top Performers', 'Role Clarity & Expectations', 'Personal Fuel – Vision & Goals', 'Structure & Accountability', 'The Cycle of Achievement'];
  const day2Curriculum = ['Mastering the Approach', 'Talking to Strangers', 'Meta-Verbal Mastery', 'The 10-Step Approach Cycle', 'Handling Objections', 'Rules & Standards', '30-Day Commitment Challenge'];
  const characteristics = [{
    icon: Zap,
    title: 'Mindset + Skillset',
    desc: 'Rookies gain identity, purpose, and habits'
  }, {
    icon: Users,
    title: 'Universal & Transferable',
    desc: 'Works across all door-to-door industries'
  }, {
    icon: Target,
    title: 'Immersive & Realistic',
    desc: 'No sugarcoating—reps leave clear on the challenge'
  }, {
    icon: Award,
    title: 'Commitment-Driven',
    desc: 'Ends with a 30-day pledge for accountability'
  }];
  return <SlideLayout data-id="element-233" data-mp="4o3nm32kdcdl">
      <div className="flex flex-col h-full justify-center space-y-8 sm:space-y-12" data-id="element-234" data-mp="4mj3l7dvlbtz">
        {/* Header */}
        <div className="text-center space-y-6" data-id="element-235" data-mp="3vt2c2fw8opp4">
          <motion.div initial={{
          opacity: 0,
          scale: 0.8
        }} animate={{
          opacity: 1,
          scale: 1
        }} className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-gradient-to-br from-orange-500/20 to-red-600/20 border border-orange-500/30 mb-4" data-id="element-236" data-mp="386dq9j440d38">
            <Flame className="w-10 h-10 text-orange-500" data-id="element-237" data-mp="2peb3dq0vk0kj" />
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-4xl md:text-5xl font-bold text-white" data-id="element-238" data-mp="2kfrlq1tbdaxz">
            Sales School
          </motion.h2>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} data-id="element-239" data-mp="3ivp68uhpj88y">
            <span className="inline-block px-4 py-2 rounded-full bg-orange-500/10 border border-orange-500/30 text-orange-400 font-semibold tracking-wide uppercase text-sm" data-id="element-240" data-mp="2r7dswc8h37g9">
              Two-Day Live Sales School
            </span>
          </motion.div>
        </div>

        {/* Curriculum Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-5xl mx-auto w-full" data-id="element-241" data-mp="ffgytiw9flic">
          {/* Day 1 */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.2
        }} className="bg-slate-900/40 border border-slate-800 rounded-xl p-6 sm:p-8 flex flex-col" data-id="element-242" data-mp="kebh8jqbf81x">
            <div className="mb-6 pb-4 border-b border-slate-800" data-id="element-243" data-mp="1v4q1x05tb5yv">
              <h3 className="text-2xl font-bold text-white mb-1" data-id="element-244" data-mp="1q6y8u2tfldt3">Day 1</h3>
              <p className="text-orange-400 font-medium" data-id="element-245" data-mp="1m6eawx11a65w">
                Foundation, Mindset & Structure
              </p>
              <p className="text-slate-500 text-sm mt-1" data-id="element-246" data-mp="1h68hbbb7e9l6">7.5 Hours</p>
            </div>

            <ul className="space-y-3 mb-8 flex-1" data-id="element-247" data-mp="1c8zugxf41hdl">
              {day1Curriculum.map((item, idx) => <li key={idx} className="flex items-start text-slate-300" data-id="element-248" data-mp="17a5e024m84wn" data-mpi={idx}>
                  <CheckCircle2 className="w-5 h-5 text-orange-500/50 mr-3 shrink-0 mt-0.5" data-id="element-249" data-mp="36mhismncai9o" />
                  <span data-id="element-250" data-mp="31md5f5hqa3no">{item}</span>
                </li>)}
            </ul>

            <div className="bg-slate-800/50 rounded-lg p-4 border border-slate-700/50" data-id="element-251" data-mp="39nu7xo6muwrw">
              <p className="text-sm text-slate-400" data-id="element-252" data-mp="3emnjvc69ufpy">
                <span className="text-orange-400 font-bold uppercase text-xs tracking-wider block mb-1" data-id="element-253" data-mp="3em5glvl6z18j">
                  Outcome
                </span>
                Clear-eyed, motivated, and personally committed
              </p>
            </div>
          </motion.div>

          {/* Day 2 */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.3
        }} className="bg-slate-900/40 border border-slate-800 rounded-xl p-6 sm:p-8 flex flex-col" data-id="element-254" data-mp="2qvi6r4rpu1jc">
            <div className="mb-6 pb-4 border-b border-slate-800" data-id="element-255" data-mp="27xyttq24zyrn">
              <h3 className="text-2xl font-bold text-white mb-1" data-id="element-256" data-mp="2bzssxtwooupp">Day 2</h3>
              <p className="text-orange-400 font-medium" data-id="element-257" data-mp="2bz0tu93voeuo">
                Skills, Communication & Confidence
              </p>
              <p className="text-slate-500 text-sm mt-1" data-id="element-258" data-mp="1ocf5o5n8l2t8">7.5 Hours</p>
            </div>

            <ul className="space-y-3 mb-8 flex-1" data-id="element-259" data-mp="1oerun2rewdfs">
              {day2Curriculum.map((item, idx) => <li key={idx} className="flex items-start text-slate-300" data-id="element-260" data-mp="229u1bs4326tn" data-mpi={idx}>
                  <CheckCircle2 className="w-5 h-5 text-orange-500/50 mr-3 shrink-0 mt-0.5" data-id="element-261" data-mp="1xbsgb1n3jxfj" />
                  <span data-id="element-262" data-mp="2c8ji1hk8tl8b">{item}</span>
                </li>)}
            </ul>

            <div className="bg-slate-800/50 rounded-lg p-4 border border-slate-700/50" data-id="element-263" data-mp="27arq4njllz44">
              <p className="text-sm text-slate-400" data-id="element-264" data-mp="2l1eeblrqg6ly">
                <span className="text-orange-400 font-bold uppercase text-xs tracking-wider block mb-1" data-id="element-265" data-mp="2h12sw6rjq29f">
                  Outcome
                </span>
                Knowing what to say and believing they can do it
              </p>
            </div>
          </motion.div>
        </div>

        {/* Characteristics Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 max-w-6xl mx-auto w-full" data-id="element-266" data-mp="1np5wr30wzzm7">
          {characteristics.map((char, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4 + idx * 0.1
        }} className="bg-slate-900/30 border border-slate-800/50 rounded-lg p-4 hover:bg-slate-800/50 transition-colors" data-id="element-267" data-mp="1rnlpzonla482" data-mpi={idx}>
              <char.icon className="w-6 h-6 text-orange-500 mb-3" data-id="element-268" data-mp="2fglofbhbwcja" />
              <h4 className="text-white font-bold text-sm mb-1" data-id="element-269" data-mp="2kedhw9xmg6pl">
                {char.title}
              </h4>
              <p className="text-slate-400 text-xs leading-relaxed" data-id="element-270" data-mp="l2b1x9o7hugo">
                {char.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </SlideLayout>;
}